(function () {
  'use strict';

  if (window.__parisWishlistButtonInit) return;
  window.__parisWishlistButtonInit = true;

  var SELECTOR = '.buy-buttons__wishlist';

  var syncLabel = function (btn) {
    var added = btn.getAttribute('data-added') === 'true';
    var label = added
      ? btn.getAttribute('data-label-remove')
      : btn.getAttribute('data-label-add');

    if (!label) return;

    btn.setAttribute('aria-label', label);

    var srOnly = btn.querySelector('.sr-only');
    if (srOnly) srOnly.textContent = label;
  };

  var animate = function (btn) {
    btn.classList.remove('is-animating');
    void btn.offsetWidth;
    btn.classList.add('is-animating');

    window.setTimeout(function () {
      btn.classList.remove('is-animating');
    }, 450);
  };

  document.addEventListener('click', function (event) {
    var btn = event.target.closest(SELECTOR);
    if (!btn) return;
    animate(btn);
  });

  var observeButton = function (btn) {
    if (btn.dataset.parisWlObserved) return;
    btn.dataset.parisWlObserved = 'true';
    syncLabel(btn);

    new MutationObserver(function () {
      syncLabel(btn);
    }).observe(btn, { attributes: true, attributeFilter: ['data-added'] });
  };

  var scan = function () {
    document.querySelectorAll(SELECTOR).forEach(observeButton);
  };

  scan();

  if (document.body) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
})();
